<template>
  <div class="container">
    <div class="login-container">
      <div class="leftBox">
        <div class="headerBox">
          <img :src="loginIcon" />
          微域大语言模型智能医助
        </div>
      </div>

      <div class="rightBox">
        <div class="tit Tip">用户注册</div>
        <div class="tit">请使用个人真实信息完成注册</div>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-position="top"
        >
          <el-form-item label="手机号码" prop="account">
            <el-input
              class="inputDeep"
              type="text"
              v-model="ruleForm.account"
              autocomplete="off"
              placeholder="请输入手机号"
              maxlength="11"
              @input="ruleForm.account = ruleForm.account.replace(/[^\d]/g, '')"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="name">
            <el-input
              class="inputDeep"
              type="text"
              v-model="ruleForm.name"
              autocomplete="off"
              placeholder="请尽量使用真实姓名进行注册"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              class="inputDeep"
              type="password"
              v-model="ruleForm.password"
              autocomplete="off"
              placeholder="密码由6位以上大写字母，小写字母和数字组成"
            ></el-input>
          </el-form-item>

          <el-form-item label="重复密码" prop="passwordRepeat">
            <el-input
              class="inputDeep"
              type="password"
              v-model="ruleForm.passwordRepeat"
              autocomplete="off"
              placeholder="请重复输入登录密码"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              class="customBtn"
              type="primary"
              @click="submitForm('ruleForm')"
              >立即注册</el-button
            >
          </el-form-item>
          <div class="notRegister">
            已有账号？去 <span @click="loginFun">登录</span>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import loginIcon from "@/assets/img/loginIcon.png";
import loginBg from "@/assets/img/loginBg.png";
import Vue from "vue";
// import { mapActions } from "vuex";
// import { setItem, getItem, removeItem } from "@/utils/auth"; // get token from cookie
import { userRegsiter } from "@/api/getData.js";
export default {
  name: "register",
  data() {
    var number = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入登录账号"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入登录密码"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      loginIcon,
      loginBg,
      login: {
        backgroundImage: "url(" + require("../../assets/img/loginBg.png") + ")",
        backgroundSize: "100%",
      },
      ruleForm: {
        account: "",
        name: "",
        password: "",
        passwordRepeat: "",
      },
      rules: {
        account: [{ validator: number, trigger: "blur" }],
        name: [{ required: true, message: "请输入用户名称", trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        password: [
          { required: true, validator: validatePass, trigger: "blur" },
          {
            pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/,
            message: "密码由6位以上大写字母，小写字母和数字组成",
            trigger: "blur",
          },
        ],
        passwordRepeat: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
        //
      },
    };
  },
  mounted() {},
  methods: {
    // /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/

    // ...mapActions(["SET_TOKEN", "setUserInfo", "setCropInfo", "setRoutes"]),
    loginFun() {
      this.$router.push("/login");
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          userRegsiter(this.ruleForm).then((res) => {
            console.log(res, "res");
            if (res.code == 200 && res.data) {
              sessionStorage.setItem("adminToken", res.data.access_token);
              this.$router.push({ path: "/" });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.container {
  min-height: 100%;
  background: rgb(243, 244, 245);
  display: flex;
  align-items: center;
}

.historyBox {
  margin-right: -40px;
}

.login-container {
  height: 721px;
  width: 1215px;
  overflow: hidden;
  margin: 0 auto;
  text-align: left;
  background: rgb(255, 255, 255);
  border-radius: 20px;
  box-shadow: 0px 0px 10px rgba(70, 70, 70, 0.25);
  display: flex;
  justify-content: space-between;
  .leftBox {
    width: 405px;
    background: url("~@/assets/img/loginBg.png") center center no-repeat;
    background-size: 100% 100%;
    .headerBox {
      display: flex;
      align-items: center;
      padding: 35px 0px 0px 25px;
      box-sizing: border-box;
      img {
        margin-right: 10px;
      }
    }
  }
  .rightBox {
    flex: 1;
    padding: 0px 240px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    text-align: left;
  }
  .tit {
    margin: 10px 0px;
    color: rgba(1, 1, 1, 0.8);
    font-size: 18px;
    width: 100%;
    text-align: left;
  }

  .Tip {
    font-size: 24px;
    font-weight: 600px;
  }

  .customBtn {
    width: 328px;
    height: 49px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    background: linear-gradient(
      225deg,
      rgb(1, 14, 48) 0%,
      rgb(4, 67, 148) 100%
    );
    border-radius: 10px;
  }

  .notRegister {
    font-size: 14px;
    color: rgba(1, 1, 1, 0.5);
    span {
      color: rgb(2, 38, 92);
      cursor: pointer;
    }
  }
}
</style>
